import React from 'react';
import { motion } from 'framer-motion';
export function ThreeHero() {
  return <section className="relative h-[35vh] w-full overflow-hidden" data-id="element-218">
      {/* Content */}
      <div className="relative z-20 h-full flex flex-col items-center justify-center text-center px-4" data-id="element-219">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-5xl md:text-7xl lg:text-8xl mb-6 leading-tight text-white font-hero" data-id="element-220">
          Find your AI app
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-gray-400 font-special max-w-[90%] md:max-w-none md:whitespace-nowrap" data-id="element-221">
          Explore 100+ curated AI tools with real pricing data and updates.
        </motion.p>
      </div>
    </section>;
}